// eslint-disable-next-line import/prefer-default-export
export const invertedMessages = {
  Comments: 'User_CERTCOMMENTS.ATTESTATIONS',
  'Don’t show this again for this certification': 'CONSULT_DONT_SHOW_LABEL',
  Close: 'CloseLabel',
  Error: 'certs.error',
};
